exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3_3g8{padding-left:20px;padding-right:20px}._3FKMx{margin:0 auto;padding:0 0 40px;max-width:1080px}._2zh7U{font-size:145px}._2a40Q,._2zh7U{font-weight:700;margin:0}._2a40Q{font-size:85px}.n32mo{text-align:center}._3qEcm{padding-left:0;list-style:none}._322WM{font-size:15px;color:#484848}a,a:hover{color:#008489}.VcbSq{margin-top:12px}.Vn8Xy{margin-bottom:12px}._3YZ-x{margin-bottom:48px}.AoTlM{margin-top:48px}", ""]);

// exports
exports.locals = {
	"root": "_3_3g8",
	"container": "_3FKMx",
	"textJumbo": "_2zh7U",
	"textMedium": "_2a40Q",
	"textCenter": "n32mo",
	"listStyled": "_3qEcm",
	"subTitle": "_322WM",
	"spaceTop2": "VcbSq",
	"space2": "Vn8Xy",
	"space6": "_3YZ-x",
	"spaceTop6": "AoTlM"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/notFound/NotFound.css
// module id = 2626
// module chunks = 15